// Single source of truth for routes that must NEVER be indexed (admin/auth/private).
// Used by both Seo.jsx (per-page robots meta) and NoIndexGuard (global, covers
// logged-out crawler renders where a page may not mount <Seo>).
const EXACT = new Set([
  "/admin",
  "/profile",
  "/favorites",
  "/login",
  "/messages",
  "/radar",
  "/alerts",
  "/notifications",
  "/pro",
  "/pro/fiche",
  "/pro/organisateur",
  "/publier-une-opportunite",
  "/submit",
  "/directory/join",
]);

const PREFIXES = ["/admin/", "/messages/", "/payment/"];

export function isPrivatePath(path = "") {
  if (EXACT.has(path)) return true;
  return PREFIXES.some((p) => path.startsWith(p));
}
